// @flow

import * as React from 'react';

import { Base } from '@gandi/ui';

import styles from './ProductsList.scss';

type Props = {
  /** `children` must render `<li>` elements */
  children: React.Node,
};

export default function ProductsList({ children }: Props): React.MixedElement {
  return (
    <Base
      tagName="ul"
      padding="none"
      margin="none"
      listStyleType="none"
      className={styles.root}
    >
      {children}
    </Base>
  );
}
